var _excluded = ["children", "placement", "shouldWrapChildren", "tooltipLabel"],
  _excluded2 = ["placement", "tooltipLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Tooltip as ChakraTooltip } from '@chakra-ui/react';
import useTheme from "../constants/theme/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var Tooltip = _ref => {
  var {
      children,
      placement = 'top',
      shouldWrapChildren = false,
      tooltipLabel
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var theme = useTheme();
  var {
    arrowShadowColor,
    color,
    shadowColor
  } = theme.components.Tooltip.baseStyle({});
  var boxShadow = "0px 0 5px " + shadowColor;
  var themeProps = {
    bg: 'white',
    boxShadow,
    borderRadius: '3px',
    color,
    fontSize: "" + theme.fontSizes.md,
    fontWeight: "" + theme.fontWeights.normal,
    maxW: '300px',
    padding: '13px 16px'
  };
  var tooltipAriaLabel = typeof tooltipLabel === 'string' ? tooltipLabel : '';
  return ___EmotionJSX(React.Fragment, null, tooltipLabel ? ___EmotionJSX(ChakraTooltip, _extends({
    "aria-label": tooltipAriaLabel,
    "data-testid": "sp-ui-tooltip",
    arrowShadowColor: arrowShadowColor,
    hasArrow: true,
    label: tooltipLabel,
    placement: placement,
    shouldWrapChildren: shouldWrapChildren
  }, themeProps, props), children) : ___EmotionJSX(React.Fragment, null, children));
};
export default Tooltip;
export function withTooltip(Component, shouldWrapChildren) {
  if (shouldWrapChildren === void 0) {
    shouldWrapChildren = false;
  }
  return _ref2 => {
    var {
        placement,
        tooltipLabel
      } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    var component = ___EmotionJSX(Component, props);
    return ___EmotionJSX(Tooltip, {
      placement: placement,
      shouldWrapChildren: shouldWrapChildren,
      tooltipLabel: tooltipLabel
    }, component);
  };
}